<form novalidate #currentForm="ngForm">
  <div class="form-group">
    <label>Email</label>
    <input required type="text" name="email" [(ngModel)]="emailAddress.email" class="form-control form-control-sm" />
    <div class="invalid-feedback d-block" *ngIf="!emailAddress.email && formSubmitted">Email is required</div>
  </div>
  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control form-control-sm" name="notes" [(ngModel)]="emailAddress.notes"></textarea>
  </div>
  <div class="form-row">
    <div class="col">
      <button type="button" (click)="save(currentForm)" class="btn btn-primary btn-block" [disabled]="formSubmitting">
        Save
        <span *ngIf="formSubmitting">
          &nbsp;
          <i class="fas fa-pulse fa-spinner fa-fw"></i>
        </span>
      </button>
    </div>
    <div class="col">
      <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="formSubmitting" (click)="saved.emit(false)">Cancel</button>
    </div>
  </div>
</form>
